import React from 'react'
import {features} from 'helpers/constants'
import {urls} from 'helpers/url'
import {t} from "helpers/language"

export const skill = {
  key: 'SETUP_DELIVERIES',
  group: 'deliveries',
  label: t('Set up deliveries'),
  desc: t('Set up your system ready for you to manage delivering your completed jobs to your customer'),
  feature: features.DELIVERIES_LICENCE,
  steps: [
    {
      content: (
        <div>
          The <i>Deliveries</i> module allows you to print and track delivery notes, schedule and plan future deliveries,
          provide tracking links and delivery update notifications to your customers, plan collections and even track
          returns.<br/>
          <br/>
          Learn how to set up deliveries now to get started.
        </div>
      ),
      actions: [
        {
          label: 'Set Up Deliveries',
          primary: true,
          type: 'next',
        },
        {
          label: 'Not Now',
          flat: true,
          type: 'close',
        },
      ],
    },
    {
      target: '.settings-deliveries-scene-delivery-methods',
      location: urls.settings.deliveryMethodsUrl,
      placement: 'bottom',
    },
    {
      location: urls.settings.deliveryEmailsUrl,
      target: '.settings-deliveries-scene-delivery-email-settings',
      placement: 'bottom',
    },
    {
      target: '.settings-deliveries-scene-collection-email-settings',
      location: urls.settings.collectionEmailsUrl,
      placement: 'bottom',
    },
    {
      target: '.settings-deliveries-scene-invoice-without-delivery-field',
      location: urls.settings.deliverySettingsUrl,
      placement: 'bottom',
      content: (
          <div>
            Do you sometimes invoice your customers <b>before</b> you{'\''}ve delivered the goods? If not, you can restrict
            this process so you can only invoice <b>after</b> delivery. To do this, simply turn this setting off.<br/>
            <br/>
            Continue now to learn about raising delivery notes.
          </div>
      ),
      actions: [
        {
          label: 'Learn about delivery notes',
          flat: true,
          primary: false,
          type: 'skill',
          skill: 'ADD_DELIVERY_NOTE',
        },
        {
          label: 'Finish',
          flat: true,
          primary: true,
          type: 'finish',
        },
      ],
    },
  ],
}

export default skill
